export { default } from "./AdminConsoleFacultyAdderSchoolAdminSection";
